export const BASE_URL = 'https://hospital-management-api.smartrec.ng';